import React from 'react'
import ErrorBoundary from '@fs/zion-error-boundary'
import SubNav from '@fs/tree-subnav-legacy'
import { Switch, Route, NotFound, Redirect } from '@fs/zion-router'

// Once we have more than one route supported in this app, we should lazy load this.
import OverviewPage from './components/overview/OverviewPage'

function App() {
  return (
    <ErrorBoundary>
      <SubNav page="overview" />
      <Switch>
        <Redirect exact from="/" to="/overview" />
        <Route requirePersonalData exact path="/overview" component={OverviewPage} />
        <Route component={NotFound} />
      </Switch>
    </ErrorBoundary>
  )
}
export default App
